import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { FaX } from 'react-icons/fa6'
import { useSearchParams } from 'react-router-dom'
import { z } from 'zod'

import { Button } from '../../../../components/Button'
import { Input } from '../../../../components/Input'

interface FilterProductsFormModalProps {
  onClose: () => void
}

const filterProductsFormSchema = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  code: z.string().optional(),
})

type FilterProductsFormData = z.infer<typeof filterProductsFormSchema>

export function FilterProductsFormModal({ onClose }: FilterProductsFormModalProps) {
  const [searchParams, setSearchParams] = useSearchParams()

  const { register, handleSubmit } = useForm<FilterProductsFormData>({
    resolver: zodResolver(filterProductsFormSchema),
    defaultValues: {
      id: searchParams.get('id') || '',
      name: searchParams.get('name') || '',
      code: searchParams.get('code') || '',
    },
  })

  function handleFilterProducts(data: FilterProductsFormData) {
    setSearchParams(state => {
      if (data.id) {
        state.set('id', data.id)
      } else {
        state.delete('id')
      }
      if (data.name) {
        state.set('name', data.name)
      } else {
        state.delete('name')
      }
      if (data.code) {
        state.set('code', data.code)
      } else {
        state.delete('code')
      }

      state.set('page', '1')
      return state
    })

    onClose()
  }

  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen bg-black/65 flex items-center justify-center z-[10000]"
      onClick={onClose}
    >
      <div
        className="flex flex-col bg-slate-100 relative rounded-md p-4 w-[80vw] max-h-[80dvh] md:w-96"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="flex justify-between mb-4">
          <h1 className="font-semibold">
            Filtros de produtos
          </h1>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
          >
            <FaX />
          </Button>
        </header>
        <form
          className="flex flex-col space-y-4 w-full"
          onSubmit={handleSubmit(handleFilterProducts)}
        >
          <div>
            <Input
              placeholder="ID"
              id="id"
              label="Id do produto"
              {...register('id')}
            />
          </div>
          <div>
            <Input
              label="Nome"
              id="name"
              {...register('name')}
            />
          </div>
          <div>
            <Input
              label="Código"
              id="code"
              {...register('code')}
            />
          </div>
          <footer className="ml-auto pt-4">
            <Button
              type="submit"
              size="sm"
            >
              Filtrar
            </Button>
          </footer>
        </form>
      </div>
    </div>
  )
}
